import { isObject } from '../../../components/miscUtils';
import { getAssetTypeName } from '../../../data/assets/helpers';
import { selectTemplatesAndCombinedOntology } from '../../../data/templateSlice';
import styles from '../Settings.module.scss';
import { useAppSelector } from '../../../app/hooks';
import { useEffect, useState } from 'react';

interface FilterTagAreaProps {
  scopeValue: string;
  selectedTemplateTypeTag: string;
  setSelectedTemplateTypeTag: (selectedTemplateTypeValue: string) => void;
}

const FilterTagArea = (props: FilterTagAreaProps) => {
  const { templates, ontology } = useAppSelector(selectTemplatesAndCombinedOntology);
  const { scopeValue, selectedTemplateTypeTag, setSelectedTemplateTypeTag } = props;

  const [localTypeFilter, setLocalTypeFilter] = useState('');
  const templateTypeTagsByScope: string[] = [];

  if (scopeValue !== '' && templates[scopeValue]) {
    Object.entries(templates[scopeValue]).map(([key, innerValue]) => {
      if (isObject(innerValue) && templateTypeTagsByScope.indexOf(key) === -1) {
        templateTypeTagsByScope.push(key);
      }
    });
  }

  useEffect(() => {
    setLocalTypeFilter(selectedTemplateTypeTag);
  }, [selectedTemplateTypeTag]);

  if (templateTypeTagsByScope.length !== 0) {
    return (
      <div className={styles.templateTypeWrapper}>
        {templateTypeTagsByScope.map((templateType: any, index: number) => (
          <div
            key={index}
            className={
              !localTypeFilter || localTypeFilter == templateType
                ? styles.templateTypeTagActive
                : styles.templateTypeTag
            }
            onClick={() => {
              let newFilter = '';
              if (templateType != localTypeFilter) newFilter = templateType;
              setLocalTypeFilter(newFilter);
              selectedTemplateTypeTag != templateType
                ? setSelectedTemplateTypeTag(templateType)
                : setSelectedTemplateTypeTag('');
            }}
          >
            {ontology.assetTypes[templateType] ? getAssetTypeName(ontology.assetTypes[templateType]) : templateType}
            &nbsp;
          </div>
        ))}
      </div>
    );
  }
};

export default FilterTagArea;
